'use client';

import {
  ScrollArea as ShadcnScrollArea,
  ScrollBar as ShadcnScrollBar,
} from '@/app/_components/ui/scroll-area';

export const ScrollArea = ShadcnScrollArea;
export const ScrollBar = ShadcnScrollBar;

export default ScrollArea;
